import React from 'react';
import {Card} from 'antd';
import styles from './styles';
import './styles.css';


const Maincard = (props) => {
    return(
        <>
        <Card
            bordered
            style={styles.card}
            className="card"
            cover={<img alt="example" style={styles.cardImg} src={props.image} />}
             >
            <div style={{textAlign: 'center'}}>
                <a href="#"><h1 style={styles.cardHead} className="card-head">{props.cardHead}</h1></a>
                <p style={styles.cardPara} className="card-para">{props.para}</p>
            </div>
             </Card>
        </>
    )
}

export default Maincard;